import React from "react";
import TerminalTable from "./terminalTable";
import { connect } from "react-redux";

import { parseApplications } from "../../../constants/parse/application";
import * as actions from "../../../actions";
import DotSpinner from "@/components/dotSpinner/dotSpinner";

class TerminalLs extends React.Component {
  componentDidMount() {
    this.props.fetchApplicationsByOrganization();
    this.props.fetchApiProducts();
  }

  render() {
    const { applications } = this.props;
    if (!applications || applications.length === 0) {
      return <DotSpinner message="Please wait" loading />;
    }
    return (
      <div>
        {applications && (
          <TerminalTable
            head={["Title", "Organization", "Client Id Dev", "Client Id Prod"]}
            body={applications.map((app) => [
              app.title,
              app.organizationName !== "" ? app.organizationName : "Loading",
              app.clientId.development,
              app.clientId.production,
            ])}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  applications: parseApplications(state.application?.applicationsById),
});

const mapDispatchToProps = (dispatch) => ({
  fetchApiProducts: () => {
    dispatch(actions.fetchApiProducts());
  },
  fetchApplicationsByOrganization: () => {
    dispatch(actions.fetchApplicationsByOrganization());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TerminalLs);
